import React from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../i18n/LanguageContext';
import LanguageSwitcher from './LanguageSwitcher';

export default function Footer() {
  const { t, getRouteUrl } = useLanguage();
  const { footer, contactInfo } = t;
  const homeUrl = getRouteUrl('home');

  return (
    <footer className="bg-[#24171a] text-stone-300 py-20 border-t border-[#382327]">
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-16">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12 md:gap-8 items-start">
          
          {/* Brand & Social */}
          <div className="md:col-span-4 space-y-6">
            <Link to={homeUrl} className="inline-block">
              <span className="text-3xl font-serif font-bold text-white tracking-wider uppercase">
                Eliana Wine
              </span>
            </Link>
            <p className="text-sm leading-relaxed max-w-xs text-stone-300 italic">
              {footer.tagline}
            </p>
            <div className="pt-2">
              <LanguageSwitcher variant="footer" />
            </div>
            <div className="flex space-x-8 text-[10px] font-bold tracking-[0.3em] uppercase pt-2">
              <a href="#" className="text-stone-300 hover:text-white transition-colors">Instagram</a>
              <a href="#" className="text-stone-300 hover:text-white transition-colors">Facebook</a>
            </div>
          </div>

          {/* Navigation */}
          <div className="md:col-span-2 space-y-6">
            <h3 className="text-[10px] font-bold tracking-[0.4em] uppercase text-[#c5a059]">
              {footer.navTitle}
            </h3>
            <ul className="space-y-3">
              {t.nav.map((link) => (
                <li key={link.name}>
                  <Link 
                    to={link.href} 
                    className="text-xs uppercase tracking-widest text-stone-200 hover:text-[#c5a059] transition-colors font-medium"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div className="md:col-span-3 space-y-6">
            <h3 className="text-[10px] font-bold tracking-[0.4em] uppercase text-[#c5a059]">
              {footer.contactTitle}
            </h3>
            <div className="space-y-4">
              <div className="space-y-1">
                <span className="block text-[9px] font-bold uppercase tracking-[0.3em] text-stone-400">
                  {t.common.email}
                </span>
                <span className="text-xs text-stone-200 tracking-wide">{contactInfo.email}</span>
              </div>
              <div className="space-y-1">
                <span className="block text-[9px] font-bold uppercase tracking-[0.3em] text-stone-400">
                  {t.common.phone}
                </span>
                <span className="text-xs text-stone-200 tracking-wide">{contactInfo.phone}</span>
              </div>
              <div className="space-y-1">
                <span className="block text-[9px] font-bold uppercase tracking-[0.3em] text-stone-400">
                  {t.contactPage.addressLabel}
                </span>
                <span className="text-xs text-stone-200 tracking-wide">{contactInfo.address}</span>
              </div>
              <div className="space-y-1">
                <span className="block text-[9px] font-bold uppercase tracking-[0.3em] text-stone-400">
                  {t.contactPage.cvrLabel}
                </span>
                <span className="text-xs text-stone-200 tracking-wide">{contactInfo.cvr}</span>
              </div>
            </div>
          </div>

          {/* Newsletter */}
          <div className="md:col-span-3 space-y-6">
            <h3 className="text-[10px] font-bold tracking-[0.4em] uppercase text-[#c5a059]">
              {footer.newsletterTitle}
            </h3>
            <p className="text-xs text-stone-300 leading-relaxed uppercase tracking-widest">
              {footer.newsletterText}
            </p>
            <form className="flex flex-col space-y-3" onSubmit={(e) => { e.preventDefault(); alert(t.common.thankYouMessage); }}>
              <input 
                type="email" 
                placeholder={footer.newsletterPlaceholder}
                className="bg-[#170e10] border border-[#3d272b] rounded-[10px] px-5 py-3 text-xs w-full text-white placeholder-stone-500 focus:outline-none focus:border-[#c5a059] transition-colors"
                required
              />
              <button className="bg-[#581c24] text-white px-5 py-3 rounded-[10px] text-[10px] font-bold uppercase tracking-[0.3em] hover:bg-[#6e232d] transition-colors border border-[#852a36]/50">
                {footer.newsletterButton}
              </button>
            </form>
          </div>

        </div>

        <div className="mt-16 pt-8 border-t border-[#382327] flex flex-col md:flex-row justify-between items-center text-[10px] font-bold tracking-widest uppercase text-stone-400 space-y-4 md:space-y-0">
          <p>{footer.copyright}</p>
          <div className="flex space-x-8">
            <a href="#" className="hover:text-stone-200 transition-colors">{t.common.terms}</a>
            <a href="#" className="hover:text-stone-200 transition-colors">{t.common.privacy}</a>
            <a href="#" className="hover:text-stone-200 transition-colors">{t.common.cookies}</a>
          </div>
        </div>
      </div>
    </footer>
  );
}
